import {
    GET_ALL_STATE,
    GET_USER_STEP,
    SET_LOADING,
    SET_MODAL,
    SET_USER_STEP
} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Button from "@/components/inputs/button";
import InputWithValidation from "@/components/inputs/inputWithValidation";
import styled from "styled-components";
import Input from "@/components/inputs/input";
import {GET_OFFER, GET_OFFER_TYPE, SET_OFFER_VALUE} from "@/store/slices/offerSlice";
import {SET_PAYMENT_DATA, SET_PAYMENT_METHOD} from "@/store/slices/paymentSlice";
import {PaymentTransform} from "@/utils/transform/payment";
import {SET_LEAD_CELULAR, SET_LEAD_DOCUMENTO, SET_LEAD_ID, SET_LEAD_TENTATIVA_TEF} from "@/store/slices/leadSlice";
import ContratoAssinatura from "@/components/texts/contratoAssinatura";

import Events from "@/utils/Events";
import Apm from "@/utils/Apm";
import { instanceOfIPedido } from "@/types/IPedido";
import { createPedido, createPedidoLead, getVoucher } from "@/api/assine";
import { blocked } from "@/utils/EmailBlockedList";
import Nullable from "@/types/utils/Nullable";
import { isDocument, isTelephoneNumber } from "@/utils/validation";
import { isProduction } from "@/utils/environment";
import useRecaptcha from "@/hooks/useRecaptcha";

const BtnValidar = styled(Button)`
  height: 50.8px;
`

export default function Voucher() {
    const events = new Events()
    const dispatch = useDispatch()
    const oferta = useSelector(GET_OFFER)
    const step = useSelector(GET_USER_STEP)
    const [btnDisabled, setBtn] = useState(false);
    const [voucherValid, setVoucher] = useState(false);
    const [hasError, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [submited, setSubmited] = useState(false);
    const states = useSelector(GET_ALL_STATE)
    const [all_states, setAllStates] = useState(states)
    const offer_type = useSelector(GET_OFFER_TYPE)
    const [telefone, setTelefone] = useState('')
    const [documento, setDocumento] = useState('')
    const [telefoneErrorMessage, setTelefoneErrorMessage] = useState<Nullable<string>>(null)
    const [documentoErrorMessage, setDocumentoErrorMessage] = useState<Nullable<string>>(null)
    const recaptcha = useRecaptcha()

    useEffect(() => {
        setAllStates(states)
    }, [states]);

    let value_offer = oferta.has_partner == true ? 0 : oferta.valor?.valor || oferta.valor?.original;

    const ecommerce = { 
        item_id: oferta.cd_oferta, 
        item_name: oferta.name,
        price: oferta.valor?.original || oferta.valor?.valor
    }

    async function submitData(event: any) {
    event.preventDefault()
    recaptcha.reset();
    const recaptchaToken = await recaptcha.validate('CHECKOUT')
    const recaptchaObj = { token: recaptchaToken, action: 'CHECKOUT' }

        let erroNoFormulario: boolean = false

        if(!isTelephoneNumber(telefone)){
            erroNoFormulario = true
            events.trigger('voucher_erro_telefone', { offer_type })
            setTelefoneErrorMessage('Telefone Inválido')
        }

        if(!isDocument(documento)){
            erroNoFormulario = true
            events.trigger('voucher_erro_preencher_documento', { offer_type })
            setDocumentoErrorMessage('Documento Inválido')
        }

        if(erroNoFormulario){
            return
        }

        setTelefoneErrorMessage('')
        setDocumentoErrorMessage('')

        dispatch(SET_LEAD_DOCUMENTO(documento))
        dispatch(SET_LEAD_CELULAR(telefone))
        const url = new URL(window.location.toString())
        
        const objectToSend: any = new PaymentTransform(all_states, 'pre-pago', url, {telefone, documento})

        const obj = objectToSend.process()
        dispatch(SET_LOADING(true))
       obj.recaptcha = recaptchaObj
        if(!instanceOfIPedido(obj)){
            Apm.captureError(`OBJ NÃO ERA DO TIPO IPEDIDO NO VOUCHER, VALOR: ${JSON.stringify(obj)}`)
            return
        }

        if(await blocked(obj.responsavel.email)){
            dispatch(SET_MODAL({show: true, type: 'pagamento-duplicado'}))
            return
        }
        await createPedido(obj).then((data) => {

            events.trigger('add_payment_info', {
                event: 'add_payment_info',
                value: value_offer,
                ecommerce: ecommerce
            });

            if(typeof data === 'number'){
                Apm.captureError("DATA ERA DO TIPO NUMBER NO VOUCHER")
                return
            }

            if(typeof data === 'string'){
                Apm.captureError("DATA ERA DO TIPO STRING NO VOUCHER")
                return
            }

            if (data.id_transacao) {
                dispatch(SET_OFFER_VALUE('0'))
                dispatch(SET_USER_STEP(step + 1))
                dispatch(SET_LEAD_TENTATIVA_TEF('S'))
                createPedidoLead(states.lead.value).then((data) => {
                    let leadID = 0
                    if(typeof data === 'number'){
                        leadID = data
                    }else if(typeof data ==='string'){
                        leadID = parseInt(data)
                    }else{
                        Apm.captureError("DATA NÃO ERA UMA STRING NEM UM NUMBER EM VOUCHER!")
                        return
                    }
                    dispatch(SET_LEAD_ID(leadID))
                }).catch(err => {
                    Apm.captureError(err)
                })
            }
        }).catch((e) => {
            Apm.captureError(`Voucher() -> SubmitData(): ${e}`);
            events.trigger("concluir_voucher_negado", { offer_type })
            dispatch(SET_MODAL({type: "falha-pagamento", show: true}))
        })
        dispatch(SET_LOADING(false))

    }

    function validVoucher() {
        events.trigger("voucher_validar_codigo", { offer_type })
        const element: any = document.getElementById('voucher');
        dispatch(SET_LOADING(true))

        createPedidoLead(states.lead.value).then((data) => {
            let leadID = 0
            if(typeof data === 'number'){
                leadID = data
            }else if(typeof data ==='string'){
                leadID = parseInt(data)
            }else{
                Apm.captureError("DATA NÃO ERA UMA STRING NEM UM NUMBER EM VOUCHER!(2)")
                return
            }
            dispatch(SET_LEAD_ID(leadID))
        }).catch(err => {
            Apm.captureError(err)
        })
        if (element !== null) {
            if(!oferta.parceiro_id){
                Apm.captureError('Erro no arquivo features/Voucher/index.tsx oferta.parceiro_id era undefined')
            }

            getVoucher(element.value, oferta.parceiro_id).then((data) => {
                if (data.disponivel) {
                    dispatch(SET_PAYMENT_METHOD('pre-pago'))
                    dispatch(SET_PAYMENT_DATA(element.value))
                    dispatch(SET_OFFER_VALUE('R$ 0,00'))
                    events.trigger("voucher_validar_codigo_sucesso", { offer_type })
                    setVoucher(true)
                    setError(false)
                } else {
                    setVoucher(false)
                    setError(true)
                    setMessage("Voucher já utilizado")
                    events.trigger("voucher_ja_utilizado", { offer_type })  
                }
            }).catch((err) => {
                Apm.captureError(err);
                events.trigger("voucher_erro_validar_codigo", { offer_type })
                setError(true)

                if(err.message.toLowerCase().includes('network')){
                    err.message = 'Erro de conexão'
                }

                setMessage(err.message)
            }).finally(() => {
                dispatch(SET_LOADING(false))
                setSubmited(true)
            })
        }
    }

    return <>
        <div className={'row'}>
            <div className="col-8">
                <Input
                    name={'voucher'}
                    id={'voucher'}
                    type={'text'}
                    error={hasError}
                    message={message}
                    submited={submited}
                    placeholder={'Voucher'}
                    className={voucherValid.toString()}
                    onClick={()=> { events.trigger("voucher_codigo", { offer_type })}}
                />
            </div>
            <div className="col-4 d-flex w-auto">
                <BtnValidar type={'button'} onClick={validVoucher}>Validar</BtnValidar>
            </div>
        </div>
        <form onSubmit={submitData}>
            <div>
                <InputWithValidation
                    name={'telefone'}
                    id={'telefone'}
                    type={'text'}
                    placeholder={'Celular'}
                    OnClick={()=> {
                        events.trigger("voucher_telefone", { offer_type })
                    }}
                    onChange={setTelefone}
                    errorMessage={telefoneErrorMessage}
                    disabled={!voucherValid}
                    value={telefone}
                />
            </div>
            <div>
                <InputWithValidation
                    name={'documento'}
                    id={'documento'}
                    type={'text'}
                    placeholder={'CPF ou CNPJ'}
                    OnClick={()=> {
                        events.trigger("voucher_preencher_documento", { offer_type })
                    }}
                    onChange={setDocumento}
                    errorMessage={documentoErrorMessage}
                    disabled={!voucherValid}
                    value={documento}
                />
            </div>
            <Button
                onClick={()=>{
                    events.trigger("voucher_concluir", { offer_type })
                }}
                type={'submit'}
                disabled={isProduction() && btnDisabled || !voucherValid}
            >
                Concluir
            </Button>
            <ContratoAssinatura paymentMethod="voucher"/>
        </form>
    </>
}